import { render, staticRenderFns } from "./index-page.vue?vue&type=template&id=56485aef&"
import script from "./index-page.vue?vue&type=script&lang=js&"
export * from "./index-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports